import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const PaymentForm = () => import(/* webpackChunkName: "payment" */ '../views/PaymentForm.vue')
const AdminPanel = () => import(/* webpackChunkName: "admin" */ '../views/AdminPanel.vue')
const AdminSchedule = () => import(/* webpackChunkName: "admin-schedule" */ '../views/AdminSchedule.vue')
const ArchivedChildren = () => import(/* webpackChunkName: "children" */ '../views/ArchivedChildren.vue')
const ChildrenManagement = () => import(/* webpackChunkName: "children" */ '../views/ChildrenManagement.vue')
const PaymentSuccess = () => import(/* webpackChunkName: "payment-success" */ '../views/PaymentSuccess.vue')
const PrivacyPolicy = () => import(/* webpackChunkName: "legal" */ '../views/PrivacyPolicy.vue')
const PublicOffer = () => import(/* webpackChunkName: "legal" */ '../views/PublicOffer.vue')
const Login = () => import(/* webpackChunkName: "auth" */ '../views/Login.vue')
const MakeupSession = () => import(/* webpackChunkName: "makeup" */ '../views/MakeupSession.vue')
const ChildRegistration = () => import(/* webpackChunkName: "registration" */ '../views/ChildRegistration.vue')
const ChildSelection = () => import(/* webpackChunkName: "child-selection" */ '../views/ChildSelection.vue')
const AdditionalDocuments = () => import(/* webpackChunkName: "additional-documents" */ '../views/AdditionalDocuments.vue')
const EventsManagement = () => import(/* webpackChunkName: "events-management" */ '../views/EventsManagement.vue')
const EventRegistration = () => import(/* webpackChunkName: "event-registration" */ '../views/EventRegistration.vue')
const EventAdditionalInfo = () => import(/* webpackChunkName: "event-additional-info" */ '../views/EventAdditionalInfo.vue')

const routes = [
  {
    path: '/',
    name: 'Payment',
    component: PaymentForm
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPanel,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/schedule',
    name: 'AdminSchedule',
    component: AdminSchedule,
    meta: { requiresAuth: true }
  },
  {
    path: '/children/archived',
    name: 'ArchivedChildren',
    component: ArchivedChildren,
    meta: { requiresAuth: true }
  },
  {
    path: '/children',
    name: 'Children',
    component: ChildrenManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/success',
    name: 'Success',
    component: PaymentSuccess
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPolicy
  },
  {
    path: '/public-offer',
    name: 'PublicOffer',
    component: PublicOffer
  },
  {
    path: '/makeup',
    name: 'MakeupSession',
    component: MakeupSession
  },
  {
    path: '/registration',
    name: 'ChildRegistration',
    component: ChildRegistration
  },
  {
    path: '/child-selection',
    name: 'ChildSelection',
    component: ChildSelection
  },
  {
    path: '/additional-documents/:childId?',
    name: 'AdditionalDocuments',
    component: AdditionalDocuments,
    props: true
  },
  {
    path: '/admin/events',
    name: 'EventsManagement',
    component: EventsManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/event/:registrationLink',
    name: 'EventRegistration',
    component: EventRegistration,
    props: true
  },
  {
    path: '/event-additional-info',
    name: 'EventAdditionalInfo',
    component: EventAdditionalInfo
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Глобальная защита маршрутов
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // Инициализируем авторизацию при первом входе
  if (!authStore.isAuthenticated && authStore.token) {
    authStore.initializeAuth()
    const isValid = await authStore.checkAuth()
    if (!isValid && to.meta.requiresAuth) {
      next('/login')
      return
    }
  }
  
  // Проверяем, требует ли маршрут авторизации
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    next('/login')
  } else if (to.name === 'Login' && authStore.isLoggedIn) {
    // Если уже авторизован и пытается зайти на логин, перенаправляем в админку
    next('/admin')
  } else {
    next()
  }
})

export default router
